import { render } from "./MbDisplaypriceCaution.vue?vue&type=template&id=77dd66c0&scoped=true"
import script from "./MbDisplaypriceCaution.vue?vue&type=script&lang=js"
export * from "./MbDisplaypriceCaution.vue?vue&type=script&lang=js"

import "./MbDisplaypriceCaution.vue?vue&type=style&index=0&id=77dd66c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77dd66c0"

export default script